module.exports = __webpack_public_path__ + "media/images/expert__placeholder--right-0beeee52c3d6a2de75eabebd0eb12f2c.png";